import React, { FC } from 'react';
import { Skeleton, Stack, useTheme } from '@mui/material';
import { DashboardCard } from '@monorepo/nova-ui';

export const PnlCardSkeleton: FC = () => {
  const theme = useTheme();

  return (
    <DashboardCard
      sx={{
        flexDirection: 'column',
        gap: 2,
        justifyContent: 'space-between',
        width: '100%',
      }}
    >
      {/* Title and value section */}
      <Stack sx={{ width: '100%' }}>
        {/* Title */}
        <Skeleton variant="text" width="75%" height={20} sx={{ mb: 1 }} />

        {/* Value and tag row */}
        <Stack direction="row" gap={2} alignItems="center">
          {/* Large value */}
          <Skeleton
            variant="text"
            width={100}
            height={theme.typography.pxToRem(28)}
            sx={{
              fontSize: theme.typography.pxToRem(28),
              fontWeight: theme.typography.fontWeightMedium,
            }}
          />

          {/* Tag */}
          <Skeleton variant="rounded" width={70} height={24} />
        </Stack>
      </Stack>

      {/* Progress bar section */}
      <Stack sx={{ width: '100%' }}>
        {/* Progress bar labels */}
        <Stack direction="row" justifyContent="space-between" mb={1}>
          <Skeleton variant="text" width={80} height={16} />
          <Skeleton variant="text" width={60} height={16} />
        </Stack>

        {/* Progress bar */}
        <Skeleton variant="rounded" width="100%" height={8} />

        {/* Progress bar values */}
        <Stack direction="row" justifyContent="space-between" mt={1}>
          <Skeleton variant="text" width={70} height={16} />
          <Skeleton variant="text" width={80} height={16} />
        </Stack>
      </Stack>
    </DashboardCard>
  );
};
